import * as React from "react";
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export function FacilityIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 5L5.42857 4V3H6.57143V4L10 5V12V13V21H9V14.75L6.57143 19H5.42857L3 14.75V21H2V13V12V5ZM4 6H5V13H4V6ZM12 9L22 10V12L21 11.9V19V20V21H12V19H19V11.7L12 11V9ZM14 13H12V17H14V13ZM17 13H15V17H17V13Z"/>
    </SvgIcon>
  )
};